import { useState, useEffect } from 'react';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import useDesktopChecker from './useDesktopChecker';

const getDefaultZoomScaleMobile = (): number => {
  const screenWidth = globalThis.innerWidth;
  if (screenWidth >= 430) return 0.65;
  if (screenWidth <= 375) return 0.55;
  return 0.6;
};

export const useZoom = (fileType: string | null) => {
  const isDesktop = useDesktopChecker();
  const [scale, setScale] = useState(0.85);

  const zoomPluginInstance = zoomPlugin();

  const defaultZoomScaleDesktop = fileType === 'image' ? 1 : 0.85;
  const defaultZoomScaleMobile = fileType === 'image' ? 1 : getDefaultZoomScaleMobile();
  const defaultZoomScale = isDesktop ? defaultZoomScaleDesktop : defaultZoomScaleMobile;

  useEffect(() => {
    setScale(defaultZoomScale);
  }, [defaultZoomScale]);

  const handleZoomIn = () => {
    setScale(prevScale => {
      const newScale = prevScale + 0.1;
      if (fileType === 'pdf') {
        zoomPluginInstance.zoomTo(newScale);
      }
      return newScale;
    });
  };

  const handleZoomOut = () => {
    setScale(prevScale => {
      const newScale = Math.max(defaultZoomScale, prevScale - 0.1);
      if (fileType === 'pdf') {
        zoomPluginInstance.zoomTo(newScale);
      }
      return newScale;
    });
  };

  const isZoomOutDisabled = scale <= defaultZoomScale;

  return {
    scale,
    defaultZoomScale,
    zoomPluginInstance,
    handleZoomIn,
    handleZoomOut,
    isZoomOutDisabled
  };
};